"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEncodedData = exports.getFormEncodedData = void 0;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var getFormEncodedData = function getFormEncodedData(data) {
  var urlEncodedDataPairs = [];

  for (var name in data) {
    urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
  } // Combine the pairs into a single string and replace all %-encoded spaces to
  // the '+' character; matches the behaviour of browser form submissions.


  return urlEncodedDataPairs.join('&').replace(/%20/g, '+');
};

exports.getFormEncodedData = getFormEncodedData;

var getEncodedData = function getEncodedData(data) {
  var urlEncodedDataPairs = []; // Turn the data object into an array of URL-encoded key/value pairs.

  for (var name in data) {
    urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
  } // Combine the pairs into a single string and replace all %-encoded spaces to
  // the '+' character; matches the behaviour of browser form submissions.


  return urlEncodedDataPairs.join('&').replace(/%20/g, '+');
};

exports.getEncodedData = getEncodedData;